module.exports = __webpack_public_path__ + "static/media/download_on_ios.0f3514a4.svg";